import React from 'react';

const SOURCE_OPTIONS = [
  { value: 'public', label: 'Public' },
  { value: 'internal', label: 'Internal' },
];

const TYPE_OPTIONS = [
  { value: 'intelligence', label: 'Intelligence' },
  { value: 'position', label: 'Positions' },
  { value: 'milestone', label: 'Milestones' },
  { value: 'meeting', label: 'Meetings' },
];

const CATEGORY_OPTIONS = [
  { value: 'product', label: 'Product' },
  { value: 'funding', label: 'Funding' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'kpi', label: 'KPI' },
  { value: 'team', label: 'Team' },
  { value: 'valuation', label: 'Valuation' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'milestone', label: 'Milestone' },
  { value: 'other', label: 'Other' },
];

function TimelineFilters({
  filters,
  onFilterChange,
  onClearFilters,
  showCompanySearch = true,
  hasActiveFilters = false,
}) {
  const toggleSource = (source) => {
    const current = filters.sources || [];
    const updated = current.includes(source)
      ? current.filter((s) => s !== source)
      : [...current, source];
    onFilterChange({ sources: updated });
  };

  const toggleType = (type) => {
    const current = filters.eventTypes || [];
    const updated = current.includes(type)
      ? current.filter((t) => t !== type)
      : [...current, type];
    onFilterChange({ eventTypes: updated });
  };

  const toggleCategory = (cat) => {
    const current = filters.categories || [];
    const updated = current.includes(cat)
      ? current.filter((c) => c !== cat)
      : [...current, cat];
    onFilterChange({ categories: updated });
  };

  return (
    <div className="timeline-filters">
      {/* Company search */}
      {showCompanySearch && (
        <>
          <input
            type="text"
            className="timeline-company-search"
            placeholder="Search company..."
            value={filters.company || ''}
            onChange={(e) => onFilterChange({ company: e.target.value })}
          />
          <div className="timeline-filter-separator" />
        </>
      )}

      {/* Source pills (data origin) */}
      <div className="timeline-filter-group">
        <span className="timeline-filter-label">Source</span>
        <div className="timeline-filter-pills">
          {SOURCE_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`timeline-pill ${(filters.sources || []).includes(opt.value) ? 'active' : ''}`}
              data-source={opt.value}
              onClick={() => toggleSource(opt.value)}
            >
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="timeline-filter-separator" />

      {/* Event type pills */}
      <div className="timeline-filter-group">
        <span className="timeline-filter-label">Type</span>
        <div className="timeline-filter-pills">
          {TYPE_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`timeline-pill ${(filters.eventTypes || []).includes(opt.value) ? 'active' : ''}`}
              data-type={opt.value}
              onClick={() => toggleType(opt.value)}
            >
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="timeline-filter-separator" />

      {/* Category pills */}
      <div className="timeline-filter-group">
        <span className="timeline-filter-label">Category</span>
        <div className="timeline-filter-pills">
          {CATEGORY_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`timeline-pill ${(filters.categories || []).includes(opt.value) ? 'active' : ''}`}
              data-category={opt.value}
              onClick={() => toggleCategory(opt.value)}
            >
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="timeline-filter-separator" />

      {/* Date range */}
      <div className="timeline-filter-group">
        <span className="timeline-filter-label">From</span>
        <input
          type="date"
          className="timeline-date-input"
          value={filters.dateFrom || ''}
          onChange={(e) => onFilterChange({ dateFrom: e.target.value })}
        />
        <span className="timeline-filter-label">To</span>
        <input
          type="date"
          className="timeline-date-input"
          value={filters.dateTo || ''}
          onChange={(e) => onFilterChange({ dateTo: e.target.value })}
        />
      </div>

      {/* Clear */}
      {hasActiveFilters && (
        <button className="timeline-filter-clear" onClick={onClearFilters}>
          Clear filters
        </button>
      )}
    </div>
  );
}

export default TimelineFilters;
